import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Container } from '@plone/components';
import MobileNavigation from '@kitconcept/volto-light-theme/components/MobileNavigation/MobileNavigation';
import { useIntl, defineMessages } from 'react-intl';
import config from '@plone/volto/registry';
import cx from 'classnames';
import IntranetSearchWidget from '@kitconcept/volto-light-theme/components/SearchWidget/IntranetSearchWidget';

import Anontools from '@plone/volto/components/theme/Anontools/Anontools';
import LanguageSelector from '@plone/volto/components/theme/LanguageSelector/LanguageSelector';
import Logo from '@plone/volto/components/theme/Logo/Logo';
import Navigation from '../Navigation/Navigation';
import SearchWidget from '@plone/volto/components/theme/SearchWidget/SearchWidget';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';

import SlotRenderer from '@plone/volto/components/theme/SlotRenderer/SlotRenderer';

import { isHCoreLanding } from '../../../../../helpers/isHCoreLanding';
import hCoreLogo from '../../../../../theme/assets/images/H_CORE-Logo.svg';

const messages = defineMessages({
  siteLabel: {
    id: 'siteLabel',
    defaultMessage: ' ',
  },
});

const InternetHeader = ({ pathname, siteLabel, token, siteAction }) => {
  const hCoreLanding = isHCoreLanding(pathname);

  const filteredSiteActions =
    (siteAction || []).filter((item) => {
      const id = (item.id || '').toLowerCase();
      const title = (item.title || '').toLowerCase();
      return (
        !['contact', 'kontakt'].includes(id) &&
        !['contact', 'kontakt'].includes(title)
      );
    }) || [];

  return (
    <>
      <div className={cx('header', { 'header--hcore': hCoreLanding })}>
        {!hCoreLanding && (
          <div className="tools-wrapper">
            <div className="search-wrapper navigation-desktop">
              <div className="search">
                <SearchWidget />
              </div>
            </div>

            <LanguageSelector />

            <div className="tools navigation-desktop">
              {!token && <Anontools />}
              {filteredSiteActions.map((item) => (
                <UniversalLink key={item.url} href={item.url}>
                  {item.title}
                </UniversalLink>
              ))}
            </div>

            {siteLabel && (
              <div className="intranet">
                <p>{siteLabel}</p>
              </div>
            )}
          </div>
        )}

        <div className="logo-nav-wrapper">
          <div className="logo">
            {hCoreLanding ? (
              <UniversalLink href={pathname}>
                <img src={hCoreLogo} alt="H-Core Logo" />
              </UniversalLink>
            ) : (
              <Logo />
            )}
          </div>

          {hCoreLanding && <LanguageSelector />}

          {!hCoreLanding && (
            <>
              <Navigation pathname={pathname} />
              <MobileNavigation pathname={pathname} />
            </>
          )}
        </div>
      </div>
    </>
  );
};

const IntranetHeader = ({ pathname, siteLabel, token, siteAction }) => {
  const hCoreLanding = isHCoreLanding(pathname);

  const filteredSiteActions =
    (siteAction || []).filter((item) => {
      const id = (item.id || '').toLowerCase();
      const title = (item.title || '').toLowerCase();
      return (
        !['contact', 'kontakt'].includes(id) &&
        !['contact', 'kontakt'].includes(title)
      );
    }) || [];

  return (
    <>
      <div className={cx('header', { 'header--hcore': hCoreLanding })}>
        {!hCoreLanding && (
          <div className="tools-wrapper">
            <div className="search-wrapper">
              <div className="search">
                <IntranetSearchWidget />
              </div>
            </div>

            <LanguageSelector />

            <div className="tools">
              {!token && <Anontools />}
              {filteredSiteActions.map((item) => (
                <UniversalLink key={item.url} href={item.url}>
                  {item.title}
                </UniversalLink>
              ))}
            </div>

            {siteLabel && (
              <div className="intranet">
                <p>{siteLabel}</p>
              </div>
            )}
          </div>
        )}

        <div className="logo-nav-wrapper">
          <div className="logo">
            {hCoreLanding ? (
              <UniversalLink href={pathname}>
                <img src={hCoreLogo} alt="H-Core Logo" />
              </UniversalLink>
            ) : (
              <Logo />
            )}
          </div>

          {hCoreLanding && <LanguageSelector />}

          {!hCoreLanding && (
            <>
              <Navigation pathname={pathname} />
              <MobileNavigation pathname={pathname} />
            </>
          )}
        </div>
      </div>
    </>
  );
};

const Header = (props) => {
  const { pathname } = props;
  let siteLabel = config.settings.siteLabel;
  const intranetHeader = config.settings.intranetHeader;
  const token = useSelector((state) => state.userSession.token);
  const content = useSelector((state) => state.content.data);
  const siteAction = useSelector(
    (state) => state.content.data?.['@components']?.actions?.site_actions,
  );
  const navRoot = useSelector((state) => state.navroot?.data?.navroot);
  const intl = useIntl();
  const translatedSiteLabel = intl.formatMessage(messages.siteLabel);

  siteLabel =
    siteLabel &&
    (translatedSiteLabel !== 'siteLabel' && translatedSiteLabel !== ' '
      ? translatedSiteLabel
      : siteLabel);

  return (
    <>
      <SlotRenderer name="aboveHeader" content={content} navRoot={navRoot} />
      <header
        className={cx('header-wrapper', { 'intranet-header': intranetHeader })}
      >
        <Container layout>
          {intranetHeader ? (
            <IntranetHeader
              pathname={pathname}
              siteLabel={siteLabel}
              token={token}
              siteAction={siteAction}
            />
          ) : (
            <InternetHeader
              pathname={pathname}
              siteLabel={siteLabel}
              token={token}
              siteAction={siteAction}
            />
          )}
        </Container>
      </header>
    </>
  );
};

Header.propTypes = {
  token: PropTypes.string,
  pathname: PropTypes.string.isRequired,
};

Header.defaultProps = {
  token: null,
};

export default Header;
